'use strict';

export default function NoItems({
    title,
    description,
    button,
    onClick = undefined,
    link = undefined,
    disabled = false,
}) {
    
    title = title || __('search.empty.title');
    description = description || __('search.empty.subtitle');
    button = button || __('search.empty.button');
    
    return <div className="el-empty">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="el-empty__btn">
            {link && <a href={link} className="button button-round2">{button}</a>}
            {!link && <a role="button" className={cn("button button-round2", disabled && 'disabled')} onClick={() => !disabled && onClick && onClick()}>{button}</a>}
        </div>
    </div>
}
